import React from "react";
import { IonItem, IonLabel, IonAccordion } from "@ionic/react";

export interface Props {}

const HomeMenuFunction: React.FC<Props> = () => {
  return (
    <IonAccordion value="HomeMenuFunction">
      <IonItem slot="header" color="light">
        <IonLabel>Home Menu and Functions</IonLabel>
      </IonItem>
      <div className="ion-padding" slot="content">
        <ul>
          <li>
            Dashboard &ndash; this is your control panel for easy access to all
            quiz functions
          </li>
          <li>
            Review Questions &ndash; use this feature to review the questions in
            your quiz. By clicking on each question you can review each question
            with the associated media.
          </li>
          <li>
            Teams &ndash; edit the details of an existing team, remove a team,
            or add a team at any stage
          </li>
          <li>Scoring &ndash; score any round of your quiz at any time</li>
          <li>
            Tools &ndash; a series of tools are available to assist with
            clearing data and resuming. Read each option carefully to understand
            each function.
          </li>
          <li>
            Other Functions
            <ol>
              <li>Cast icon &ndash; start or stop casting to your screen(s)</li>
              <li>
                Music icon &ndash; turn on background music during the
                introductory cycle or during scoring, or to skip to the next
                song
              </li>
              <li>
                Search icon &ndash; jump to another section of the quiz or to
                any question or answer
              </li>
            </ol>
          </li>
        </ul>
      </div>
    </IonAccordion>
  );
};

export default HomeMenuFunction;
